import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

const useHandleViewMore = (ref: RefObject<HTMLDivElement>) => {
  const [viewMore, setViewMore] = useState(false);

  const toggleHeight = () => {
    if (ref?.current) {
      // eslint-disable-next-line no-param-reassign
      ref.current.style.webkitLineClamp = 'unset';
      setViewMore(false);
    }
  };

  const callBack = () => {
    if (ref?.current) {
      setViewMore(ref.current.scrollHeight > ref.current.clientHeight);
    }
  };

  useEffect(callBack, [ref]);
  useEffect(() => {
    window.addEventListener('resize', callBack);
    return () => {
      window.removeEventListener('resize', callBack);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { viewMore, toggleHeight };
};

export default useHandleViewMore;
